import React, { type ReactElement } from 'react';
import BaseMarkerBadge from 'feature-components/badges/marker-badges/base-marker-badge';
import type { ConstructedMarker } from 'pages/marking/types';
import { useAuthCustomerUser } from 'services/providers/auth.hooks';

type Props = {
  marker: ConstructedMarker;
};

/**
 * A version of the marker badge that assumes that the organisation user has already been allocated
 * to a response and displays a red error badge if the TestInstanceResponseMarker relation is not
 * found. Requires that the organisation user is passed in as a subobject of the marker. Useful when
 * a mark does not exist yet.
 */
export default function AllocatedMarkerBadge({ marker }: Props): ReactElement {
  const currentOrganisationUser = useAuthCustomerUser();

  const displayWarning =
    currentOrganisationUser && currentOrganisationUser.id !== marker.organisationUser.id;

  return (
    <BaseMarkerBadge
      displayWarning={displayWarning ?? false}
      activeMarker={marker}
      organisationUser={marker.organisationUser}
      autoscored={false} // Only human markers could have been allocated.
    />
  );
}
